/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Loading_SetsInputs */

const en_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading sets... please wait...`)
};

const fr_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des ensembles... veuillez patienter...`)
};

const de_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets werden geladen... Bitte warten...`)
};

const it_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dei set... attendere prego...`)
};

const ru_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка наборов... пожалуйста, подождите...`)
};

const es_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando conjuntos... por favor espere...`)
};

const zh_cn2_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载设置……请稍候……`)
};

const ja_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットを読み込んでいます...お待ちください...`)
};

const hi_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट लोड हो रहे हैं... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_tags_manager_loading_sets = /** @type {(inputs: Tags_Manager_Loading_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando conjuntos... aguarde...`)
};

/**
* | output |
* | --- |
* | "Loading sets... please wait..." |
*
* @param {Tags_Manager_Loading_SetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_loading_sets = /** @type {((inputs?: Tags_Manager_Loading_SetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Loading_SetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_loading_sets(inputs)
	if (locale === "de") return de_tags_manager_loading_sets(inputs)
	if (locale === "it") return it_tags_manager_loading_sets(inputs)
	if (locale === "ru") return ru_tags_manager_loading_sets(inputs)
	if (locale === "es") return es_tags_manager_loading_sets(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_loading_sets(inputs)
	if (locale === "ja") return ja_tags_manager_loading_sets(inputs)
	if (locale === "hi") return hi_tags_manager_loading_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_loading_sets(inputs)
	return en_tags_manager_loading_sets(inputs)
});